import { has } from 'lodash-es'
import MUTATION_TYPES from './mutation-types'
import CONSTANTS from './constants'

export default {
  [MUTATION_TYPES.SET_SEARCH_PARAMS]: (state, params) => {
    // console.log('SET_SEARCH_PARAMS')
    // console.log(params)
    Object.entries(params).forEach(([key, value]) => {
      if (has(state, key)) {
        state[key] = value
      } else {
        console.log(`Missing search store key:${key}`)
      }
    })
    // state[CONSTANTS.SEARCH_PARAMS] = { ...state[CONSTANTS.SEARCH_PARAMS], ...params }
  },
  [MUTATION_TYPES.SET_SEARCH_REQUEST]: (state, value) => {
    state[CONSTANTS.SEARCH_REQUEST] = value
  },
  [MUTATION_TYPES.SET_SEARCH_SKU]: (state, value) => {
    state[CONSTANTS.SEARCH_SKU] = value
  },
}
